import { render } from "./ColonySpace.vue?vue&type=template&id=8a4c32bc&ts=true"
import script from "./ColonySpace.vue?vue&type=script&lang=ts"
export * from "./ColonySpace.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__